import { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { CURRENCY, TABLE_ITEMS, TITLE, TOTAL, WAFFY_FEES } from "./constants";
import { IContractProps } from "../../models";
import { ContractSubTitle } from "../../titles";

// styles
import styles from "./styles.module.css";
import classNames from "classnames";
import { Divider } from "@mui/material";
import { DeliveryLabel } from "./deliveryLabel";
import DeliveryInfoModal from "./deliveryInfoModal";

export const PaymentDetails = ({ contract }: IContractProps) => {
  const [showDeliveryInfoModal, setShowDeliveryInfoModal] = useState(false);
  function createRow(desc: string, price: number) {
    return { desc, price };
  }
  const subTotal = contract?.totalAmount - contract?.fee;
  const total = subTotal - contract?.fee;

  const rows = [
    createRow(TABLE_ITEMS.NET_PRICE, contract?.itemPrice || 0),
    createRow(TABLE_ITEMS.DELIVERY_FEES, contract?.shipment?.fee || 0),
    createRow(TABLE_ITEMS.SUB_TOTAL, subTotal || 0),
  ];
  return (
    <TableContainer className={styles.container}>
      <DeliveryInfoModal
        contract={contract}
        open={showDeliveryInfoModal}
        onClose={() => setShowDeliveryInfoModal(false)}
      />
      <ContractSubTitle text={TITLE} />
      <Table aria-label="spanning table">
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={row.desc}>
              <TableCell
                className={classNames(
                  index + 1 !== rows.length
                    ? styles.table_cell
                    : styles.table_cell_strong,
                  index + 1 !== rows.length && styles.desc,
                  index + 1 === rows.length && styles.divider
                )}>
                {row.desc === TABLE_ITEMS.DELIVERY_FEES ? (
                  <DeliveryLabel
                    onClick={() => setShowDeliveryInfoModal(true)}
                  />
                ) : (
                  row.desc
                )}
              </TableCell>
              <TableCell
                className={classNames(
                  index + 1 !== rows.length
                    ? styles.table_cell
                    : styles.price_subtotal,
                  index + 1 !== rows.length && styles.price,
                  index + 1 === rows.length && styles.divider
                )}
                align="right">
                {row.price} <span className={styles.currency}>{CURRENCY}</span>
              </TableCell>
            </TableRow>
          ))}

          <TableRow>
            <TableCell className={classNames(styles.table_cell, styles.desc)}>
              {WAFFY_FEES}
            </TableCell>
            <TableCell
              className={classNames(styles.table_cell, styles.price)}
              align="right">
              {contract?.fee}{" "}
              <span className={styles.currency}>{CURRENCY}</span>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell className={classNames(styles.table_cell, styles.total)}>
              {TOTAL}
            </TableCell>
            <TableCell
              className={classNames(styles.table_cell, styles.price_total)}
              align="right">
              {total} <span className={styles.currency}>{CURRENCY}</span>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
